<template>
  <div class="admin-panel" style="width: 100%">
    <MakcInput
      v-model="adminPanelQuery"
      @input="adminPanelSearch"
      :field-type="'text'"
    ></MakcInput>
    <div class="admin-panel-prompt" v-if="showList">
      <div class="admin-panel-prompt-item" v-for="(item) in adminPanelList" :key="item.AG_ID" @click="setClient(item.AG_ID)">
        <div class="admin-panel-prompt-item-name">
          {{ item.LAST_NAME + ' ' + item.FIRST_NAME + ' '  + item.MIDDLE_NAME }}
        </div>
        <div class="admin-panel-prompt-item-policy">
          {{ item.POLICY_SERIAL + ' № ' + item.POLICY_NUMBER }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MakcInput from "@/profile/components/UI/MakcInputComponent.vue";

export default {
    name: "AdminPanelComponent",
  components: {MakcInput},
    data: () => {
        return {
          adminPanelQuery: '',
          adminPanelList: [],
          showList: false,
        }
    },
    methods: {
      async adminPanelSearch() {
        if (this.adminPanelQuery.length < 3) {
          return;
        }
        let params = {
          action: "ac-client",
          object: "cpa",
          data_part: this.adminPanelQuery,
          token: this.$myApp.token.get(),
        }
        let api = await this.$api2.get(params);

        if (api.success) {
          this.adminPanelList = api.data.clients;
          this.showList = true;
        }
        if (api.error) {
          this.$myApp.errors.set(api.errors);
        }
      },
      async setClient(ag_id) {
        this.showList = false;
        let params = {
          action: "change-client",
          object: "cpa",
          client_id: ag_id,
          token: this.$myApp.token.get(),
        }
        let api = await this.$api2.get(params);

        if (api.success) {
          this.$emit('setClient', true);
          this.$forceUpdate();
        }
        if (api.error) {
          this.$myApp.errors.set(api.errors);
        }
      },
    },
}
</script>

<style scoped>
.admin-panel {
  width: 100%;
  position: relative;
}
.admin-panel-prompt {
  position: absolute;
  background-color: white;
  border: 1px solid black;
  width: 100%;
  z-index: 1;
}
.admin-panel-prompt-item {
  width: 100%;
  display: flex;
}
.admin-panel-prompt-item:hover {
  background-color: #8e9298;
}
.admin-panel-prompt-item-name {width: 60%}
.admin-panel-prompt-item-policy {width: 40%}
</style>